"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Documents = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const Documents_style_1 = require("./Documents.style");
const GlobalStyles_1 = require("../../../../helper/GlobalStyles");
const atome_1 = require("../../../atome");
const organisms_1 = require("../../../organisms");
const molecules_1 = require("../../../molecules");
const hooks_1 = require("../../../../store/hooks");
const reducers_1 = require("../../../../store/reducers");
const User_service_1 = __importDefault(require("../../../../services/User.service"));
const CommonModal_1 = require("../../../atome/CommonModal/CommonModal");
// @ts-ignore
function Documents({ navigation, route }) {
    const userInfo = (0, hooks_1.useAppSelector)(reducers_1.selectUserInformation);
    const auth = (0, hooks_1.useAppSelector)(reducers_1.selectAuth);
    const dispatch = (0, hooks_1.useAppDispatch)();
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [saveSuccess, setSaveSuccess] = (0, react_1.useState)(false);
    const [deletableFiles, setDeletableFiles] = (0, react_1.useState)([]);
    const [existingDocumentModalVisible, setExistsingDocumentModalVisible] = (0, react_1.useState)(false);
    const save = async () => {
        setSaveSuccess(true);
        setTimeout(() => {
            setSaveSuccess(false);
            navigation.navigate(route.params?.page === 'my-documents'
                ? 'Dashboard'
                : 'CaseHistoryOverview');
        }, 1000);
    };
    const getUserFiles = (0, react_1.useCallback)(async () => {
        setLoading(true);
        const fileResponse = await User_service_1.default.getFiles();
        if (fileResponse.error) {
            console.log(fileResponse);
        }
        if (!fileResponse.error) {
            dispatch((0, reducers_1.setUserInformation)({ ...userInfo, file: fileResponse.data }));
        }
        setLoading(false);
    }, [userInfo]);
    (0, react_1.useEffect)(() => {
        if (!auth.isAuthenticated) {
            navigation.navigate('Login');
            setLoading(false);
        }
    }, [userInfo, auth]);
    (0, react_1.useEffect)(() => {
        return navigation.addListener('focus', async () => {
            setDeletableFiles([]);
            if (!userInfo.file || userInfo.file.length === 0) {
                await getUserFiles();
            }
        });
    }, [getUserFiles]);
    if (loading) {
        return react_1.default.createElement(atome_1.Loading, null);
    }
    const onExistingDocumentModalClose = async () => {
        setExistsingDocumentModalVisible(false);
        await getUserFiles();
    };
    const showExistsingDocumentModalVisible = () => setExistsingDocumentModalVisible(true);
    return (react_1.default.createElement(atome_1.ProtectedPage, { navigation: navigation },
        react_1.default.createElement(react_native_1.SafeAreaView, null,
            react_1.default.createElement(react_native_1.ScrollView, null,
                react_1.default.createElement(organisms_1.UserHeader, { navigation: navigation }),
                react_1.default.createElement(react_native_1.View, { style: Documents_style_1.styles.container },
                    react_1.default.createElement(react_native_1.View, { style: { marginBottom: 40 } },
                        react_1.default.createElement(atome_1.Text, { style: [Documents_style_1.styles.heading2] }, "Dokumente"),
                        react_1.default.createElement(atome_1.Label, { style: [GlobalStyles_1.globalStyles.marginTop15] }, "Ihre medizinischen Dokumente m\u00FCssen Ihren Krankheitsverlauf dokumentieren. Dies k\u00F6nnen entweder mehrere Dokumente von verschiedenen Zeitpunkten oder ein Arztbrief, der Ihren Krankehitsverlauf schildert."),
                        react_1.default.createElement(atome_1.Label, { style: [GlobalStyles_1.globalStyles.marginTop15] }, "Diese \u00E4rztl. Dokumente k\u00F6nnen als Diagnosenachweis hochgeladen werden:"),
                        react_1.default.createElement(atome_1.Label, { style: [GlobalStyles_1.globalStyles.marginTop15] },
                            react_1.default.createElement(react_native_1.View, { style: { flexDirection: 'row' } },
                                react_1.default.createElement(atome_1.Text, { style: [GlobalStyles_1.globalStyles.textBold] }, '\u2022'),
                                react_1.default.createElement(atome_1.Text, { style: [{ paddingLeft: 5 }, GlobalStyles_1.globalStyles.textBold] },
                                    "Nachweis \u00FCber Diagnose(n)",
                                    '\n',
                                    react_1.default.createElement(atome_1.Text, { style: [GlobalStyles_1.globalStyles.textUnBold] }, "(nicht \u00E4lter als 2021) z.B. Arztbrief, Attest oder Gutachten")))),
                        react_1.default.createElement(atome_1.Label, { style: [GlobalStyles_1.globalStyles.marginTop15, GlobalStyles_1.globalStyles.marginBottom15] },
                            react_1.default.createElement(react_native_1.View, { style: [{ flexDirection: 'row' }] },
                                react_1.default.createElement(atome_1.Text, { style: [GlobalStyles_1.globalStyles.textBold] }, '\u2022'),
                                react_1.default.createElement(atome_1.Text, { style: [{ paddingLeft: 5 }, GlobalStyles_1.globalStyles.textBold] },
                                    "Nachweis \u00FCber Therapieversuche",
                                    '\n',
                                    react_1.default.createElement(atome_1.Text, { style: [GlobalStyles_1.globalStyles.textUnBold] }, "(nicht \u00E4lter als 2021) z.B. Arztbrief oder Rezepte")))),
                        react_1.default.createElement(atome_1.Label, null, "Falls Ihnen diese Dokumente nicht vorliegen, erhalten Sie diese problemlos von Ihrem Haus- oder Facharzt.")),
                    react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.row, Documents_style_1.styles.documentWrapper] },
                        react_1.default.createElement(molecules_1.DocumentBox, { type: "new", reload: getUserFiles, setLoading: setLoading, deletableFiles: deletableFiles, setDeletableFiles: setDeletableFiles, showExistsingDocumentModalVisible: showExistsingDocumentModalVisible }),
                        userInfo.file?.map((file, index) => {
                            if (file.type === 'other') {
                                return (react_1.default.createElement(molecules_1.DocumentBox, { filetype: "other", key: index, id: file.id, type: "document", filename: file.filename, thumb: file.thumbnail, reload: getUserFiles, setLoading: setLoading, canDelete: deletableFiles.some(deletableFile => file.filename === deletableFile) || !userInfo?.progress.isDataConfirm }));
                            }
                        })),
                    userInfo.file?.length > 0 ? (react_1.default.createElement(react_native_1.View, null,
                        userInfo.file.some(file => file.type === 'prescription') ? (react_1.default.createElement(atome_1.Text, { style: [Documents_style_1.styles.heading2] }, "Meine Rezepte")) : null,
                        react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.row, Documents_style_1.styles.documentWrapper] }, userInfo.file?.map((file, index) => {
                            if (file.type !== 'other') {
                                return (react_1.default.createElement(molecules_1.DocumentBox, { filetype: "prescription", fileCreated: file.created, key: index, id: file.id, type: "document", filename: file.filename, thumb: file.thumbnail, reload: getUserFiles, setLoading: setLoading, canDelete: deletableFiles.some(deletableFile => file.filename === deletableFile) || !userInfo?.progress.isDataConfirm }));
                            }
                        })))) : null,
                    saveSuccess && (react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.row, Documents_style_1.styles.saveMessageContainer] },
                        react_1.default.createElement(atome_1.Text, { style: [Documents_style_1.styles.saveMessageText] }, "Speichern erfolgreich"))),
                    !userInfo?.progress.isDataConfirm && (react_1.default.createElement(react_native_1.View, { style: [
                            GlobalStyles_1.globalStyles.row,
                            GlobalStyles_1.globalStyles.marginRow,
                            Documents_style_1.styles.buttonContainer,
                        ] },
                        react_1.default.createElement(react_native_1.Pressable, { style: Documents_style_1.styles.button, onPress: save },
                            react_1.default.createElement(atome_1.Text, { style: [Documents_style_1.styles.buttonText] }, "Speichern")))),
                    !(route.params?.page === 'my-documents') && (react_1.default.createElement(react_native_1.View, { style: [
                            GlobalStyles_1.globalStyles.row,
                            GlobalStyles_1.globalStyles.marginRow,
                            Documents_style_1.styles.buttonContainer,
                        ] },
                        react_1.default.createElement(react_native_1.Pressable, { onPress: () => navigation.navigate('CaseHistoryOverview') },
                            react_1.default.createElement(atome_1.Text, { style: [Documents_style_1.styles.backButtonText] }, "\u2190 Zur\u00FCck")))))),
            react_1.default.createElement(CommonModal_1.CommonModal, { title: 'Ungültiger Dokumenten-Name', content: 'Sie haben bereits ein Dokument mit diesem Namen hochgeladen. Bitte benennen Sie das Dokument um.', visible: existingDocumentModalVisible, onClose: onExistingDocumentModalClose }))));
}
exports.Documents = Documents;
